/**
 * Shared cookie configuration for authentication cookies.
 *
 * ALL code that reads/writes auth cookies (tokenR, userR, userRId,
 * impersonation cookies, etc.) MUST use these options so the browser
 * treats them as the same cookie.  Mismatched flags (e.g. one call
 * with `secure: true` and another without) cause the browser to
 * create separate cookies which leads to auth issues.
 *
 * Security flags:
 *  - secure: cookies sent only over HTTPS (production)
 *  - sameSite: 'lax' prevents CSRF while allowing normal navigation
 */

const isPrivateNetwork = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.endsWith('.local') ||
    /^(192\.168|10\.|172\.(1[6-9]|2\d|3[01]))\./.test(window.location.hostname)
);

const isNodeProduction = typeof process !== 'undefined' && process.env?.NODE_ENV === 'production';
const isBrowserProduction = typeof window !== 'undefined' && !isPrivateNetwork;

const isProduction = isBrowserProduction || (isNodeProduction && !isPrivateNetwork);

export const cookieOptions = Object.freeze({
    path: "/",
    secure: isProduction,
    sameSite: 'lax'
});
